import OutlinedToggleButton from "./OutlinedToggleButton";

import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkIcon from '@mui/icons-material/Bookmark';

import { setEntryToMyList } from "../../Utils/Api";
import { useDispatch } from "react-redux";
import { entriesActions } from "../../Store/EntriesSlice";
import { myListActions } from "../../Store/MylistSlice";
import { removeCacheAwardEntries, removeCacheMyListEntries } from "../../Utils/Entry";

export default function AddToMyListButton({ awardId, entry, categoryId = null, label = "Add to my list", onLabel = null, isOn = false, ...props }) {

    const dispatch = useDispatch();

    onLabel = onLabel ?? label;
    const displayLabel = isOn ? onLabel : label;

    function onToggle(e) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        const newActive = !isOn;

        // update API
        setEntryToMyList(awardId, entry.id, categoryId, newActive);

        // Create updated entry
        // If entry has a category specific add to my list
        const categories = categoryId
            ? Object.fromEntries(
                Object.values(entry.categories)
                    .map((cat) => {
                        console.log("cat.id === categoryId", cat.id, categoryId, cat.id === categoryId);
                        if(cat.id === categoryId){
                            cat = {...cat, isInMyList: newActive}
                        }
                        return [cat.id, cat];
                    })
            )
            : entry.categories
        ;

        const newEntry = {
            ...entry,
            categories,
            isInMyList: entry.hasCategoryPage 
                ? Object.values(categories).some(category => category.isInMyList) 
                : newActive
            ,
        };

        console.log("addtomylistbutton newEntry", newEntry);

        // Update redux
        dispatch(entriesActions.mergeEntry(newEntry));
        dispatch(myListActions.addMergeOrRemoveEntry(newEntry));
        // Update cache
        // mergeCachedAwardEntry(awardId, newEntry);
        // setCachedMyList(newEntry);
        removeCacheAwardEntries(awardId);
        removeCacheMyListEntries();
    }

    return (
        <OutlinedToggleButton 
            text={displayLabel} 
            icon={BookmarkBorderOutlinedIcon} 
            onIcon={BookmarkIcon}
            onToggle={onToggle}
            isOn={isOn}
            {...props}
        />
    );
}